import {toastStore} from "./toast.module.js";

const actions = {
  success ({ dispatch, commit }, message) {
    dispatch('addAlertItem', { severity: 'success', summary: 'Success', detail: message, life: 10000 })
  },
  successPermanent ({ dispatch, commit }, message) {
    dispatch('addAlertItem', { severity: 'success', summary: 'Success', detail: message })
  },
  error ({ dispatch, commit }, message) {
    dispatch('addAlertItem', { severity: 'error', summary: 'Error', detail: message, life: 15000 })
  },
  addAlertItem({ dispatch, commit }, item) {
      item.id = toastStore.toasts.length++;
      toastStore.toasts.push(item)
  }
}

export const alert = {
  namespaced: true,
  actions,
}
